<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">   The living and the dead: I miss them all.</p>
<p class="fm2">—Leon Wieseltier, <i>Kaddish</i></p>
<p class="fm1">We must fight old age as we would a disease.</p>
<p class="fm2">—The aged Cato</p>
<p class="fm1">   I hear it as it was now and as it is then.</p>
<p class="fm2">—Wallace Stegner, <i>Angle of Repose</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?a78e59aa